import { state, slugify } from '../../core/vue/constants';
import { computed, onMounted, onUpdated, watch } from 'vue';
import LinkCursor from '../../components/molecules/link-cursor';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import cardTemplate from '../../../templates/components/organisms/overview.html';

export default {
    template: cardTemplate,
    setup() {
        const subpages = window.subpages || [];
        state.pages = subpages;

        state.filteredPages = subpages;
        if (state.selectedFilter !== 'all') {
            changeFilter(state.selectedFilter);
        }

        // Computed properties
        const pages = computed(() => state.pages);
        const filteredPages = computed(() => state.filteredPages);
        const itemsPerPage = 8;
        const currentPage = computed(() => state.currentPage);
        const isLoading = computed(() => state.loading);
        const selectedFilter = computed(() => state.selectedFilter);
        const view = computed(() => state.view);

        const totalPages = computed(() => {
            const totalItems = state.filteredPages?.length || 0;
            return Math.ceil(totalItems / itemsPerPage);
        });

        const changeFilter = (filter) => {
            state.filteredPages = state.pages.filter((page) => {
                const filteredPages = page.excerptCategories.some((cat) => {
                    return slugify(cat.name) === filter;
                });

                return filteredPages;
            });
        };

        watch(() => state.selectedFilter, (newFilter) => {
            if (!newFilter || newFilter === 'all') {
                state.filteredPages = state.pages;
            } else {
                changeFilter(newFilter);
            }
        }, { immediate: true });

        onMounted(() => {
            const workQuicklinks = document.querySelectorAll('#pane-overview .quicklinks__item');

            if (workQuicklinks) {
                workQuicklinks.forEach((quicklink) => {
                    new LinkCursor(quicklink);
                });
            }

            ScrollTrigger.refresh();
        });

        onUpdated(() => {
            ScrollTrigger.refresh();
        });


        return {
            ...state,
            isLoading,
            pages,
            itemsPerPage,
            currentPage,
            totalPages,
            selectedFilter,
            filteredPages,
            view,
        };
    },
};
